import { Form } from '@beehive/components';
import PureFormItem from 'components/PureFormItem';
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

type Options = {
  formItemList: Record<string, any>[];
  formProps?: any;
  mode?: string;
};

const InitFormProps = {
  showClientError: false,
  isLabelVertical: false,
  itemColProps: {
    span: 24,
  },
  itemLabelColProps: {
    span: 8,
  },
  itemInputColProps: {
    span: 16,
  },
};

export const CommonForm = forwardRef((props: Options, ref: any) => {
  const { formItemList, formProps = {}, mode = 'edit' } = props;
  const [formError, setFormError] = useState(false);

  const formRef = useRef<any>(null);

  useImperativeHandle(ref, () => ({
    valid() {
      if (!formRef.current.valid()) {
        setFormError(true);
        return false;
      }
      setFormError(false);
      return true;
    },
  }));

  const isShow = mode === 'show';
  const mergeFormProps = {
    ...InitFormProps,
    ...formProps,
  };

  return (
    <Form
      ref={formRef}
      {...mergeFormProps}
      mode={mode}
      showError={formError}
      style={{ minHeight: 100 }}
    >
      {formItemList.map((formItem) => {
        const { childProps, ...reset } = formItem;
        const pureFormItemProps = {
          isShow,
          ...childProps,
          // 子选项 isShow 需求优先级更高
          formItemKey: reset.key,
        };
        if (pureFormItemProps.isShow) {
          reset.required = false;
          reset.tip = undefined;
        }
        return (
          <Form.Item {...reset} key={reset.key} itemKey={reset.key}>
            <PureFormItem {...pureFormItemProps} />
          </Form.Item>
        );
      })}
    </Form>
  );
});
